import React, { RefObject, useRef, useState, JSX } from 'react';
import { Button, Col, Collapse } from 'reactstrap';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MapsWrapper } from '../../Components/UI/Maps/MapsWrapper';
import { MapConfig, Marker, MapRefType } from '../../Components/UI/Maps/MapsInterfaces';
import Keys from '../../../_Translations/generated/service-list.en.t.json.keys';
import fallback from '../../../_Translations/generated/service-list.en.t.json';
import useTranslation from '../../Hooks/useTranslation';
import { CustomListOptions } from './externals';

const MapsMobileView = ({
  mapConfig,
  customListOptions,
  ExtendedMapMarkerPopup,
  mapRef: externalMapRef
}: {
  mapConfig?: MapConfig;
  customListOptions?: CustomListOptions;
  ExtendedMapMarkerPopup?: (maker: Marker) => JSX.Element;
  mapRef?: RefObject<MapRefType>;
}): JSX.Element => {
  const { t } = useTranslation('service-list', fallback, Keys);
  const [mapOpen, setMapOpen] = useState<boolean>(false);
  const mapRef = externalMapRef || useRef<MapRefType>(null);

  const toggleMapState = (): void => {
    if (!mapConfig?.showMapFullScreenOnClick) {
      const value = !mapOpen;
      setMapOpen(value);
    } else {
      mapRef.current?.toggleFullscreen();
    }
  };

  return (
    <div className="w-100 iso__serviceList__mapsWrapperContainer">
      <Button
        className="text-white btn-block my-2 font-weight-bold text-uppercase"
        color="primary"
        onClick={toggleMapState}
      >
        <div className="justify-content-center">
          {customListOptions?.customIcons?.map && (
            <FontAwesomeIcon icon={customListOptions?.customIcons?.map} />
          )}
          <span className="mr-2">{t(Keys.MAP)}</span>
          <span>
            {!mapOpen && <FontAwesomeIcon icon={faAngleDown} className="fas fa-lg" />}
            {mapOpen && <FontAwesomeIcon icon={faAngleUp} className="fas fa-lg" />}
          </span>
        </div>
      </Button>

      <Collapse
        isOpen={true}
        style={mapConfig?.showMapFullScreenOnClick ? { height: '0', overflow: 'hidden' } : {}}
      >
        <Col className="border border-dark pb-1">
          <MapsWrapper
            centerMap={mapConfig?.centerMap}
            markers={mapConfig?.markers}
            zoomMap={mapConfig?.zoomMap}
            mapRef={mapRef}
            ExtendedMapMarkerPopup={ExtendedMapMarkerPopup}
          />
        </Col>
      </Collapse>
    </div>
  );
};

export default MapsMobileView;
